import { memo } from "react"
import { useTranslation } from "react-i18next"
import conciliacionForzadaLogo from "../assets/concilacion-bancaria-forzada.svg"

const ConciliacionManualForzadaTemplate = memo(
  ({ onConfirm }: { onConfirm?(): void }) => {
    const { t } = useTranslation()

    return (
      <div className='tw-flex tw-flex-col tw-p-2 tw-text-center tw-gap-12'>
        <img
          className='tw-mx-auto tw-mt-16'
          src={conciliacionForzadaLogo}
          alt={`${t("bancos.conciliacion.noResults")}`}
        />
        <h3 className='tw-mx-auto tw-text-4xl tw-font-bold tw-text-primary'>
          {t("pagoCobro.forced.title")}
        </h3>
        <button
          type='button'
          value='Conciliar'
          className='tw-mx-auto hover:tw-bg-primary-dark tw-rounded !tw-bg-secondary tw-p-2 tw-px-4 tw-font-normal tw-text-white tw-transition-colors tw-duration-100 tw-ease-in-out'
          onClick={async () => {
            onConfirm?.()
          }}
        >
          {t("bancos.conciliacion.manualTable.labelRestartConciliacion")}
        </button>
      </div>
    )
  }
)

export default ConciliacionManualForzadaTemplate
